import { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { draftToHtml } from 'utils/helpers';
import { HtmlDoc } from 'shared/utils/html-doc';

export const useDraftEditorStateValue = (props) => {
  const { value: propValue, onDraftEditorStateChange, onChange } = props;

  const [draftEditorState, setDraftEditorState] = useState(null);
  const [value, setValue] = useState(propValue);

  useEffect(() => {
    if (!draftEditorState) {
      return;
    }

    const html = draftToHtml(draftEditorState);

    setValue((prevValue) => {
      if (prevValue?.html === html) {
        return prevValue;
      }

      if (isHtmlEmpty(prevValue?.html) && isHtmlEmpty(html)) {
        return prevValue;
      }

      return { ...prevValue, html };
    });

    if (onDraftEditorStateChange) {
      onDraftEditorStateChange(draftEditorState);
    }
  }, [draftEditorState]);

  useEffect(() => {
    onChange(isEmpty(value) ? null : value);
  }, [value]);

  return {
    value,
    setValue,
    draftEditorState,
    setDraftEditorState,
  };
};

const isHtmlEmpty = (html) => {
  if (isEmpty(html)) {
    return true;
  }

  const htmlDoc = HtmlDoc.fromPartialHtml(html);
  const pureText = htmlDoc.getPureText();

  return isEmpty(pureText.replace(/\s/g, ''));
};
